import { useTranslation } from 'react-i18next';

import AddReleaseNote from '@/components/manage-release-notes/add-release-note';
import StatusMessage from '@/components/shared/status-message';
import { ERROR_FEEDBACK } from '@/utils/constants';

const ReleaseNoteEmptyView = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation();

  return (
    <div className="flex-1 flex flex-col gap-4 items-center justify-center">
      <StatusMessage
        type="empty"
        title={t(ERROR_FEEDBACK.release_note.empty)}
        description={t(ERROR_FEEDBACK.release_note.description)}
        className="items-center text-center"
      />
      <AddReleaseNote onClick={onClick} showFullLabel />
    </div>
  );
};
export default ReleaseNoteEmptyView;
